/**
 * 가격에 따른 호가 단위(tick size) 반환
 * 한국 주식 시장의 호가 단위 규칙:
 * - 2,000원 미만: 1원
 * - 2,000원 이상 5,000원 미만: 5원
 * - 5,000원 이상 20,000원 미만: 10원
 * - 20,000원 이상 50,000원 미만: 50원
 * - 50,000원 이상 200,000원 미만: 100원
 * - 200,000원 이상 500,000원 미만: 500원
 * - 500,000원 이상: 1,000원
 * @param price - 주식 가격
 * @returns 호가 단위
 */
export const getTickSize = (price: number): number => {
  if (price < 2000) return 1;
  if (price < 5000) return 5;
  if (price < 20000) return 10;
  if (price < 50000) return 50;
  if (price < 200000) return 100;
  if (price < 500000) return 500;
  return 1000;
};

/**
 * 가격을 호가 단위에 맞게 조정
 * @param price - 조정할 가격
 * @returns 호가 단위에 맞춘 가격
 */
export const adjustToTickSize = (price: number): number => {
  const tickSize = getTickSize(price);
  return Math.round(price / tickSize) * tickSize;
};

